import { render } from "./legoFormRow.vue?vue&type=template&id=bdfe429c"
import script from "./legoFormRow.vue?vue&type=script&lang=js"
export * from "./legoFormRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/boxes/legoFormBox/legoFormRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bdfe429c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bdfe429c', __exports__)) {
    api.reload('bdfe429c', __exports__)
  }
  
  module.hot.accept("./legoFormRow.vue?vue&type=template&id=bdfe429c", () => {
    api.rerender('bdfe429c', render)
  })

}


export default __exports__